import { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import api from "@/utils/api";

const Promos = () => {
  const [promos, setPromos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPromos = async () => {
      try {
        const response = await api.get("/api/promos");
        setPromos(response.data);
      } catch (error) {
        setPromos([]);
      } finally {
        setLoading(false);
      }
    };
    fetchPromos();
  }, []);

  return (
    <div className="bg-white" data-testid="promos-page">
      <Seo
        title="Actualités & promotions | Fast Alu"
        description="Découvrez les promotions et actualités Fast Alu : dépannage, menuiserie et sécurité."
      />
      <section className="bg-brand-blue/5" data-testid="promos-hero">
        <div className="max-w-6xl mx-auto px-6 py-16">
          <h1 className="font-heading text-4xl uppercase" data-testid="promos-title">
            Actualités & promotions
          </h1>
          <p className="text-brand-ink/70 mt-4" data-testid="promos-subtitle">
            Restez informé des offres et nouveautés Fast Alu.
          </p>
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-6 py-16" data-testid="promos-list">
        {loading ? (
          <p data-testid="promos-loading">Chargement...</p>
        ) : promos.length === 0 ? (
          <p className="text-brand-ink/70" data-testid="promos-empty">
            Aucune promotion active pour le moment.
          </p>
        ) : (
          <div className="grid md:grid-cols-2 gap-6">
            {promos.map((promo) => (
              <div
                key={promo.id}
                className="border border-brand-blue/15 rounded-sm p-6 bg-white"
                data-testid={`promo-card-${promo.id}`}
              >
                <h2 className="font-heading text-2xl uppercase" data-testid={`promo-title-${promo.id}`}>
                  {promo.title}
                </h2>
                <p className="text-sm text-brand-ink/70 mt-2" data-testid={`promo-desc-${promo.id}`}>
                  {promo.description}
                </p>
                {(promo.start_date || promo.end_date) && (
                  <p className="text-xs text-brand-blue mt-3" data-testid={`promo-dates-${promo.id}`}>
                    {promo.start_date ? `Début : ${promo.start_date}` : ""}{" "}
                    {promo.end_date ? `Fin : ${promo.end_date}` : ""}
                  </p>
                )}
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Promos;
